export default "__VITE_ASSET__BF6mUtZw__"